import React, { useState } from "react";
import { useApp } from "../../contexts/AppContext";
import UserMenu from "../Auth/UserMenu";
import { TEMARIO } from "../../constants/temario"; // 👈 Importamos el temario

const Header = ({ setShowProfile, onOpenContact }) => {
  const {
    view,
    setView,
    isPremium,
    navigateToProtectedFeature,
    setCurrentExam,
  } = useApp();
  const [isNavOpen, setIsNavOpen] = useState(false);

  const isExamMode = view === "exam";
  const shuffleArray = (array) => {
    const newArr = [...array];
    for (let i = newArr.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [newArr[i], newArr[j]] = [newArr[j], newArr[i]];
    }
    return newArr;
  };
  // Lógica idéntica a la del Sidebar para generar el examen
  const handleSimulatorClick = () => {
    if (!isPremium) {
      navigateToProtectedFeature("exam");
      return;
    }

    const TOTAL_QUESTIONS = 100;

    // 1. Corregida la estructura de los objetos (deben tener 'id' y 'weight')
    const TOPIC_WEIGHTS = [
      { id: "t1", weight: 0.16 },
      { id: "t2", weight: 0.08 },
      { id: "t3", weight: 0.08 },
      { id: "t4", weight: 0.08 },
      { id: "t5", weight: 0.04 },
      { id: "t6", weight: 0.08 },
      { id: "t7", weight: 0.08 },
      { id: "t8", weight: 0.04 },
      { id: "t9", weight: 0.08 },
      { id: "t10", weight: 0.08 },
      { id: "t11", weight: 0.2 },
    ];

    let selectedQuestions = [];

    // 2. Selección estratificada
    TEMARIO.forEach((topic) => {
      const config = TOPIC_WEIGHTS.find((t) => t.id === topic.id);
      const weight = config ? config.weight : 0.05;
      const countForTopic = Math.round(TOTAL_QUESTIONS * weight);

      const shuffledTopicQs = shuffleArray([...topic.questions]);
      // Aseguramos no tomar más de las disponibles
      selectedQuestions.push(
        ...shuffledTopicQs.slice(
          0,
          Math.min(countForTopic, shuffledTopicQs.length)
        )
      );
    });

    // 3. Relleno si faltan preguntas hasta llegar a 100
    if (selectedQuestions.length > TOTAL_QUESTIONS) {
      selectedQuestions = selectedQuestions.slice(0, TOTAL_QUESTIONS);
    } else {
      const allQs = TEMARIO.flatMap((t) => t.questions);
      while (selectedQuestions.length < TOTAL_QUESTIONS) {
        selectedQuestions.push(allQs[Math.floor(Math.random() * allQs.length)]);
      }
    }

    // 4. MEZCLA TOTAL
    const mixedQuestions = shuffleArray([...selectedQuestions]);

    // 5. Procesamiento: Barajar opciones y reasignar índice correcto
    const freshQuestions = mixedQuestions.map((q) => {
      const correctText = q.o[q.c];
      const shuffledOptions = shuffleArray([...q.o]);
      const newCorrectIndex = shuffledOptions.indexOf(correctText);

      return {
        q: q.q,
        o: shuffledOptions,
        c: newCorrectIndex,
        exp: q.exp,
        answered: false,
        selectedAnswer: null,
      };
    });

    const simulatorExam = {
      title: "Simulación Real",
      questions: freshQuestions,
      sourceId: "simulator",
      currentIdx: 0,
      score: 0,
      timer: 0,
    };

    setCurrentExam(null);
    setTimeout(() => {
      setCurrentExam(simulatorExam);
      setView("exam");
    }, 10);
  };

  const getTitle = () => {
    const titles = {
      dashboard: "Dashboard",
      study: "Biblioteca de leyes",
      quizzes: "Práctica por temas",
      exam: "Simulación Real",
      billing: "Mi Plan",
    };
    return titles[view] || "Dashboard";
  };

  const navItems = [
    {
      id: "dashboard",
      label: "Dashboard",
      icon: "M4 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2V6zM14 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2V6zM4 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2v-2zM14 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2v-2z",
    },
    {
      id: "study",
      label: "Biblioteca de leyes",
      icon: "M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253",
    },
    {
      id: "quizzes",
      label: "Práctica por temas",
      icon: "M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7h3m-3 4h3m-6-4h.01M9 16h.01",
    },
  ];

  return (
    <header className="glass-header border-b px-4 md:px-8 py-4 flex items-center justify-between sticky top-0 z-[110]">
      <div className="flex items-center gap-2 md:gap-4">
        {!isExamMode && (
          <div className="relative lg:hidden">
            <button
              onClick={() => setIsNavOpen(!isNavOpen)}
              className={`p-2 rounded-xl transition-all ${
                isNavOpen
                  ? "bg-blue-600 text-white"
                  : "bg-slate-100 text-slate-600"
              }`}
            >
              <svg
                className="w-6 h-6"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d={
                    isNavOpen
                      ? "M6 18L18 6M6 6l12 12"
                      : "M4 6h16M4 12h16M4 18h16"
                  }
                />
              </svg>
            </button>

            {isNavOpen && (
              <>
                <div
                  className="fixed inset-0 z-30"
                  onClick={() => setIsNavOpen(false)}
                />
                <div className="absolute left-0 mt-3 w-64 bg-white rounded-2xl shadow-2xl border border-slate-200 z-40 animate-slideDown overflow-hidden">
                  <div className="p-3 space-y-1">
                    {navItems.map((item) => (
                      <button
                        key={item.id}
                        onClick={() => {
                          setView(item.id);
                          setIsNavOpen(false);
                        }}
                        className={`w-full px-4 py-3 text-left text-sm font-bold rounded-xl flex items-center gap-3 transition-all ${
                          view === item.id
                            ? "bg-blue-50 text-blue-600"
                            : "text-slate-600 hover:bg-slate-50"
                        }`}
                      >
                        <svg
                          className="w-5 h-5 opacity-70"
                          fill="none"
                          stroke="currentColor"
                          viewBox="0 0 24 24"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="2"
                            d={item.icon}
                          />
                        </svg>
                        {item.label}
                      </button>
                    ))}
                    <div className="border-t border-slate-100 my-2" />
                    {/* 👇 BOTÓN ACTUALIZADO CON LA LÓGICA DE EXAMEN */}
                    <button
                      onClick={handleSimulatorClick}
                      className="w-full px-4 py-3 text-left text-sm font-black bg-gradient-to-r from-blue-600 to-indigo-700 text-white rounded-xl flex items-center justify-between"
                    >
                      <span className="flex items-center gap-3">
                        <svg
                          className="w-5 h-5 text-blue-200"
                          fill="none"
                          stroke="currentColor"
                          viewBox="0 0 24 24"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="2"
                            d="M13 10V3L4 14h7v7l9-11h-7z"
                          />
                        </svg>
                        Simulador Real
                      </span>
                      {!isPremium && <span>🔒</span>}
                    </button>
                  </div>
                </div>
              </>
            )}
          </div>
        )}

        <h2 className="text-lg md:text-xl font-extrabold text-slate-800 tracking-tight">
          {getTitle()}
        </h2>
      </div>

      {!isExamMode ? (
        <UserMenu
          setShowProfile={setShowProfile}
          onOpenContact={() => onOpenContact(true)}
        />
      ) : (
        <button
          onClick={() => setView("quizzes")}
          className="px-4 py-2 text-xs font-bold text-slate-500 hover:text-red-600 transition-colors bg-slate-100 rounded-lg"
        >
          SALIR
        </button>
      )}
    </header>
  );
};

export default Header;
